import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

function VerifyCode() {
    console.log("does anything log?");

        const [formData, setFormData] = useState({
          digit1: '',
          digit2: '',
          digit3: '',
          digit4: '',
          digit5: '',
          digit6: '',
          email: ''

        });
        //const navigate = useNavigate();

        const handleInputChange = (e) => {
          const { name, value } = e.target;
          setFormData(prevData => ({
            ...prevData,
            [name]: value,
          }));

          if (name === 'digit1') 
          document.getElementById('digit2').focus();
          else if (name === 'digit2')
          document.getElementById('digit3').focus();
          else if (name === 'digit3')
          document.getElementById('digit4').focus();
          else if (name === 'digit4')
          document.getElementById('digit5').focus();
          else if (name === 'digit5')
          document.getElementById('digit6').focus();
        };

        const navigate = useNavigate();
        const handleSubmit = async (event) => {
          event.preventDefault();
    
          //console.log(formData);
          const bodyObj = {
            "username": formData.email,
            "confirmation_code": formData.digit1 + formData.digit2 + formData.digit3 + formData.digit4 + formData.digit5 + formData.digit6
          }
    
          try {
            const response = await fetch(process.env.REACT_APP_CONFIRM_SIGN_UP_URL, {
              method: 'POST',
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Connection': 'keep-alive'          },
              body: JSON.stringify(bodyObj),
            });
      
            await response.json();
      
            if (response.ok) {
              alert("success!");
              navigate('/signIn');
            } else {
              alert("error!");
            }
          } catch (error) {
            alert("network error!");
          }     
        };

      return (
    <div >


<section>
    <div className="page-header min-vh-100" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1630590874752-61fbfc9ff5a6?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80')` }}>
      <span className="mask bg-gradient-dark opacity-4"></span>
      <div className="container">
        <div className="row">
          <div className="col-lg-5 col-md-7 mx-auto">
            <div className="card">
              <div className="card-body px-lg-5 py-lg-5 text-center">
                <div className="info mb-4">
                  <div className="icon icon-shape icon-xl rounded-circle bg-gradient-warning shadow-warning text-center py-1 mx-auto">
                    <i className="material-symbols-rounded opacity-10">flight</i>
                  </div>
                </div>
                <h2>2FA Security</h2>
                <p className="mb-4">Enter the 6-digit code from the email Ohana's Shops sent you during regirstration.  For security purposes, please also re-enter your email address.</p>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-4">
                    <div className="col-lg-2 col-md-2 col-2 ps-0 ps-md-2">
                      <div className="input-group input-group-outline">
                        <input type="text" className="form-control text-lg text-center" maxLength="1" id="digit1" name="digit1" value={formData.digit1} aria-label="2fa" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2 col-2 ps-0 ps-md-2">
                      <div className="input-group input-group-outline">
                        <input type="text" className="form-control text-lg text-center" maxLength="1"  id="digit2" name="digit2" value={formData.digit2} aria-label="2fa" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2 col-2 ps-0 ps-md-2">
                      <div className="input-group input-group-outline">
                        <input type="text" className="form-control text-lg text-center" maxLength="1"  id="digit3" name="digit3" value={formData.digit3} aria-label="2fa" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2 col-2 ps-0 ps-md-2">
                      <div className="input-group input-group-outline">
                        <input type="text" className="form-control text-lg text-center" maxLength="1" id="digit4" name="digit4" value={formData.digit4} aria-label="2fa" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2 col-2 ps-0 ps-md-2">
                      <div className="input-group input-group-outline">
                        <input type="text" className="form-control text-lg text-center" maxLength="1" id="digit5" name="digit5" value={formData.digit5} aria-label="2fa" onChange={handleInputChange}/>
                      </div>
                    </div>
                    <div className="col-lg-2 col-md-2 col-2 ps-0 ps-md-2">
                      <div className="input-group input-group-outline">
                        <input type="text" className="form-control text-lg text-center" maxLength="1" id="digit6" name="digit6" value={formData.digit6} aria-label="2fa" onChange={handleInputChange}/>
                      </div>
                    </div>
                  </div>
                  <div className="input-group input-group-outline mb-3">
                <label className="form-label">Email</label>
                <input type="email" className="form-control" id="email" name="email" value={formData.email} onChange={handleInputChange}/> 
              </div>
                  <div className="text-center">
                    <button type="submit" className="btn bg-gradient-warning my-4">Submit</button>
                  </div>
                  <div>
                    <button type="button" className="btn btn-link p-0">Resend Code</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</div>
      );
    }
    
    export default VerifyCode;